<template>
  <template v-if="!skeleton">
  <div class="avatar__wrapper" :class="classes">

      <div v-if="!isBot">
        <span class="avatar__initials" v-if="!url || forceText">
          {{ initials }}
        </span>
          <img
              class="avatar__picture"
              :src="imageSrc"
              @error="forceText = true"
          />
      </div>
      <div v-else>
        <Bot class="avatar-icon" stroke="white" size="16"></Bot>
<!--        <img class="avatar__picture" :src="avatarBotUrl" alt="bot message">-->
      </div>
  </div>
  </template>
  <template v-else>
    <div class="avatar__wrapper skeleton">
    </div>
  </template>
</template>
<script>

import axios from "axios";

import startCase from 'lodash/startCase';
import split from 'lodash/split';
import {computed, onMounted, ref} from 'vue';

import { Bot } from 'lucide-vue-next';
import {useSessionStore} from "@/stores/session";

export default {
  props: ['skeleton', 'name', 'url', 'outline', 'id', 'active', 'isBot', 'authenticate'],
  components: { Bot },
  setup(props) {
    const imageSrc = ref(null);

    const session = useSessionStore();
    const sessId = session.getSessionId;

    const initials = computed(() => {
      if (!props.name) return 'A';

      const initialsArr = split(startCase(props.name), ' ').map(
          i => split(i, '')[0]
      );

      const joined = [initialsArr[0], initialsArr[1]].join('')

      const result = joined.length > 1 ? joined : props.name.substr(0,2).toUpperCase();
      return result ? result : 'A'
    });

    const classes = computed(() => {

      const result = {
        'is-image': props.url,
        'is-active': props.active,
        'no-url': !props.url
      }

      return result
    });

    const forceText = ref(false);

    const avatarBotUrl = computed(() => {
      return require('../assets/bot-avatar.png')
    })

    const loadAvatarImage = async (url) => {
        try {
            const response = await axios.get(url, {
                headers: {"Content-Type": 'image/png',"sess_id": sessId},
                responseType: "blob"
            });

            imageSrc.value = URL.createObjectURL(response.data);
        } catch (error) {
            console.error("Error loading image:", error);
        }
    }

    onMounted(() => {
        if (props.authenticate && props.url) {
            loadAvatarImage(props.url);
        } else {
            imageSrc.value = props.url;
        }
    })

    return {
      initials,
      imageSrc,
      classes,
      forceText,
      avatarBotUrl
    };
  },
};
</script>
<style lang="scss" scoped>
.avatar {
  &__wrapper {
    width: var(--avatar-size);
    height: var(--avatar-size);
    border-radius: 100%;
    position: relative;
    display: inline-flex;
    justify-content: center;
    align-items: center;

    &.is-image {
    }

    &.no-url {
      background-color: var(--avatar-bg-color);
    }

    &.skeleton {
      background-color: var(--skeleton-color);
    }

    &.is-active {
      border: solid 2px;

      animation-name: blinkingAvatar;
      animation-duration: 1s;
      animation-iteration-count: infinite;
    }

  }
  &__picture {
    display: block;
    max-width: 100%;
    overflow: hidden;
    border-radius: 100%;
  }

  &__icon {
    display: block;
    overflow: hidden;
    border-radius: 100%;
    vertical-align: middle;
  }

  &__initials {
    color: white;
    font-weight: 500;
    font-size: calc(var(--avatar-size) / 2); /* 50% of parent */
    line-height: 1;
    position: relative;
    //top: calc(var(--avatar-size) / 4); /* 25% of parent */
  }

  @keyframes blinkingAvatar {
    0% {
      border-color: var(--active-color);

    }
    50% {
      border-color: var(--primary-color);
    }
    100% {
      border-color: var(--active-color);
    }
  }
}

</style>
